<template>
  <div class="party-page-wrapper">
    <div class="party-bg"></div>

    <v-container fluid style="height: 100vh; width: 100vw" class="d-flex justify-center align-center pa-0 relative-z">
      <v-fade-transition>
        <v-card v-if="loading" dark color="#121212" width="100%" max-width="450" class="rounded-xl pa-5 text-center elevation-10">
          <v-progress-circular indeterminate color="#00E676" size="64"></v-progress-circular>
          <div class="mt-4 font-weight-bold grey--text">Lade Party-Status...</div>
        </v-card>
      </v-fade-transition>

      <v-card v-if="!loading && !isPageVisible" dark color="#121212" class="pa-10 text-center rounded-xl elevation-10" max-width="500">
        <v-icon size="80" color="grey darken-2">mdi-lock-clock</v-icon>
        <h2 class="text-h5 mt-4">Zugriff nicht möglich</h2>
        <p class="grey--text">Die Anmeldung ist momentan geschlossen.</p>
        <v-btn color="#00E676" class="black--text mt-4" rounded @click="$router.push('/')"> Zurück zum Dashboard </v-btn>
      </v-card>

      <v-card v-if="!loading && isPageVisible" class="main-card my-auto overflow-hidden elevation-24 rounded-xl" width="100%" max-width="450" dark>
        <v-btn
          v-if="ui.showControls"
          absolute
          style="top: 10px"
          left
          fab
          small
          color="rgba(0,0,0,0.6)"
          elevation="0"
          @click="$router.push('/')"
          class="z-index-10">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div ref="ticketContainer" class="ticket-canvas white--text" style="background-color: #121212">
          <v-img
            src="https://app.wellcomefit.ch/img/news/party.jpg"
            height="240"
            gradient="to bottom, rgba(0,0,0,0) 0%, #121212 100%"
            class="align-end">
            <div class="text-center pb-2" style="width: 100%">
              <v-chip color="#00E676" class="black--text font-weight-black mb-2 elevation-6" small> 28. FEBRUAR </v-chip>
              <h1 class="text-h4 font-weight-black text-uppercase text-shadow mb-0">
                well come FIT<br />
                <span style="color: #00e676">Party 2026</span>
              </h1>
            </div>
          </v-img>

          <div class="px-6 pb-6 pt-2" style="background-color: #121212">
            <div class="mb-6 text-center">
              <div class="my-3">
                <v-icon color="#00E676" small class="mb-1">mdi-map-marker-radius</v-icon>
                <div class="font-weight-bold text-subtitle-1 leading-tight">Dreiegg Frauenfeld</div>
                <div class="text-caption grey--text">Metzgerstrasse 4, 8500 Frauenfeld</div>
              </div>

              <div class="my-3">
                <div class="font-weight-bold text-subtitle-1 leading-tight">Motto: GLITZER</div>
              </div>

              <div class="mt-3 text-caption grey--text">
                <v-icon color="#00E676" x-small class="mr-1">mdi-glass-cocktail</v-icon>
                Zahlung mit <strong class="white--text">wcf Dollar</strong>
              </div>
            </div>

            <v-divider class="grey darken-3 mb-6"></v-divider>

            <div v-if="!isRegistered">
              <div class="text-center mb-6" v-if="false">
                <div class="text-overline grey--text mb-1">Verfügbare Plätze</div>
                <v-chip v-if="remainingSlots > 50" color="green darken-3" text-color="white">{{ remainingSlots }} Plätze</v-chip>
                <v-chip v-else-if="remainingSlots > 0" color="orange darken-3" text-color="white" class="pulse-animation"
                  >Nur noch {{ remainingSlots }}!</v-chip
                >
                <v-chip v-else color="red darken-3" text-color="white">Ausgebucht</v-chip>
              </div>

              <p class="text-body-1 font-weight-light mb-6 text-center px-4">
                Hey <strong>{{ user.firstName }}</strong
                >!<br />
                Wir laden dich {{ isEmployee ? "und deine Begleitung" : "" }} herzlich ein.
              </p>

              <v-text-field
                v-if="isEmployee"
                v-model="form.plusOne"
                label="Name deiner Begleitung"
                placeholder="Optional"
                outlined
                dark
                dense
                color="#00E676"
                class="mb-2 centered-input"
                hide-details="auto"></v-text-field>

              <v-btn
                block
                x-large
                color="#00E676"
                class="black--text font-weight-bold mt-6 glow-button"
                :loading="ui.processing"
                :disabled="remainingSlots <= 0"
                @click="handleSignup(true)">
                Zusagen
              </v-btn>

              <div class="text-center mt-3" v-if="isRegistered">
                <v-btn text x-small color="grey" class="text-none" @click="handleSignup(false)"> Ich kann leider nicht kommen </v-btn>
              </div>
            </div>

            <div v-else class="digital-ticket-wrapper">
              <div class="ticket-card">
                <div class="rip-line"></div>

                <div class="text-center pt-4 pb-4">
                  <div class="text-overline grey--text mb-0">Ticket von</div>
                  <div class="text-h4 font-weight-bold white--text text-truncate px-2">
                    {{ user.firstName }}
                  </div>
                  <div class="text-h5 font-weight-regular white--text text-truncate px-2 mb-2">
                    {{ user.lastName }}
                  </div>

                  <div v-if="isEmployee && hasPlusOne" class="mt-3 mb-4 p-2 rounded grey darken-4 d-inline-block px-4">
                    <div class="text-caption grey--text">Begleitung</div>
                    <div class="text-body-2 white--text font-weight-bold">{{ displayPlusOne }}</div>
                  </div>

                  <div class="mt-6">
                    <div class="py-2 px-8 rounded-pill success-gradient d-inline-flex align-center elevation-6">
                      <v-icon color="white" small class="mr-2">mdi-check-decagram</v-icon>
                      <span class="white--text font-weight-bold text-uppercase tracking-wider">Angemeldet</span>
                    </div>
                  </div>

                  <div class="mt-8 mb-0 pt-4" style="border-top: 1px dashed #333">
                    <div class="text-center text-caption grey--text text-uppercase ticket-id">
                      ID: {{ user.lastName.substring(0, 3).toUpperCase() }}-2026-WCF
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isRegistered && ui.showControls" class="px-6 pb-6 pt-0" style="background-color: #121212">
          <v-row dense justify="center">
            <v-col cols="12">
              <v-btn block large outlined color="white" class="mb-3" @click="downloadTicket" :loading="ui.generatingTicket">
                <v-icon left color="#00E676">mdi-download</v-icon> Ticket speichern
              </v-btn>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-menu offset-y top content-class="rounded-lg">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn text small color="grey darken-1" v-bind="attrs" v-on="on"> Abmelden </v-btn>
                </template>
                <v-list dense dark color="grey darken-4">
                  <v-list-item @click="confirmSignOff('full')">
                    <v-list-item-icon><v-icon color="red">mdi-close-circle</v-icon></v-list-item-icon>
                    <v-list-item-title class="red--text">Abmelden</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="isEmployee && hasPlusOne" @click="confirmSignOff('plusOne')">
                    <v-list-item-icon><v-icon>mdi-account-minus</v-icon></v-list-item-icon>
                    <v-list-item-title>Begleitung entfernen</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-container>
    <div style="position: fixed; left: -9999px; top: 0; z-index: -1">
      <div ref="exportTicket" class="export-ticket-layout">
        <div class="ticket-header">
          <img src="https://app.wellcomefit.ch/img/news/party.jpg" class="ticket-bg-img" />
          <div class="header-overlay">
            <div class="wcf-logo">well come FIT</div>
            <div class="party-title">X-MAS PARTY <span class="green--text">2026</span></div>
          </div>
        </div>

        <div class="ticket-body">
          <div class="ticket-row">
            <div class="ticket-label">DATUM</div>
            <div class="ticket-value">28. FEBRUAR 2026</div>
          </div>
          <div class="ticket-row">
            <div class="ticket-label">START</div>
            <div class="ticket-value">20:00 UHR</div>
          </div>
          <div class="ticket-row full-width">
            <div class="ticket-label">LOCATION</div>
            <div class="ticket-value">DREIEGG FRAUENFELD</div>
            <div class="ticket-sub">Metzgerstrasse 4, 8500 Frauenfeld</div>
          </div>

          <div class="dashed-line"></div>

          <div class="ticket-row full-width mt-4">
            <div class="ticket-label">GUEST</div>
            <div class="ticket-value guest-name">{{ user.firstName }} {{ user.lastName }}</div>
            <div class="ticket-sub green--text text-uppercase" v-if="isEmployee">TEAM MEMBER</div>
          </div>

          <div class="ticket-row full-width mt-2" v-if="hasPlusOne">
            <div class="ticket-label">PLUS ONE</div>
            <div class="ticket-value">{{ displayPlusOne }}</div>
          </div>

          <div class="dashed-line"></div>

          <div class="ticket-footer">
            <div class="qr-placeholder">
              <v-icon size="60" color="white">mdi-qrcode</v-icon>
            </div>
            <div class="ticket-id-box">
              <div>TICKET ID</div>
              <div class="code-font">{{ user.lastName.substring(0, 3).toUpperCase() }}-2026-WCF</div>
            </div>
          </div>

          <div class="watermark">Motto: GLITZER</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userService from "@/services/userService"
import api from "@/api"
import html2canvas from "html2canvas"
import { saveAs } from "file-saver"

export default {
  name: "PartyInviteVFinal",
  data() {
    return {
      loading: true,
      isPageVisible: false,
      isEmployee: false,
      isRegistered: false,
      remainingSlots: 0,

      form: {
        plusOne: "",
      },

      ui: {
        processing: false,
        generatingTicket: false,
        showControls: true,
      },

      interval: null,
      userService,
    }
  },

  computed: {
    user() {
      const u = this.userService.getUser()
      return u ? { firstName: u.vorname, lastName: u.nachname } : { firstName: "", lastName: "" }
    },
    hasPlusOne() {
      return this.form.plusOne && this.form.plusOne.length > 2 && this.form.plusOne.toLowerCase() !== "keine"
    },
    displayPlusOne() {
      return this.hasPlusOne ? this.form.plusOne : "Keine Begleitung"
    },
  },

  async created() {
    await this.initialize()
    this.interval = setInterval(this.fetchSlots, 15000)
  },

  beforeDestroy() {
    if (this.interval) clearInterval(this.interval)
  },

  methods: {
    async initialize() {
      try {
        const status = await api.fetchSignupAvailabilityParty()
        if (!status.visible) {
          this.isPageVisible = false
        } else {
          this.isPageVisible = true
          this.isEmployee = status.isEmployee
          this.isRegistered = status.signedUp

          let pOne = status.plusOne || ""
          if (this.isRegistered && (!pOne || pOne === "")) {
            pOne = "keine"
          }
          this.form.plusOne = pOne === "keine" ? "" : pOne
          await this.fetchSlots()
        }
      } catch (error) {
        console.error("Init Error:", error)
        this.$toast.error("Fehler beim Laden der Party-Daten")
      } finally {
        this.loading = false
      }
    },

    async fetchSlots() {
      try {
        const res = await api.fetchRemainingPartySlots()
        this.remainingSlots = res.remainingSlots
      } catch (e) {
        // Silent fail
      }
    },

    async handleSignup(isSigningUp, onlyPlusOne = false) {
      const payload = {
        signedUp: isSigningUp,
        employee: this.isEmployee,
        plusOne: isSigningUp && !onlyPlusOne && this.form.plusOne ? this.form.plusOne : null,
      }

      if (onlyPlusOne) {
        payload.signedUp = true
        payload.plusOne = null
      }

      this.ui.processing = true

      try {
        const response = await api.managePartySignup(payload)

        if (isSigningUp) {
          this.isRegistered = true
          const confirmedPlusOne = response.data?.plusOne || (payload.plusOne ? payload.plusOne : "keine")
          this.form.plusOne = confirmedPlusOne === "keine" ? "" : confirmedPlusOne
          if (!onlyPlusOne) {
            this.$toast.success("Welcome to the Party! 🟢")
          }
        } else {
          this.isRegistered = false
          this.form.plusOne = ""
          this.$toast.success("Erfolgreich abgemeldet")
        }
      } catch (error) {
        console.error(error)
        this.$toast.error("Verbindungsfehler")
      } finally {
        this.ui.processing = false
      }
    },

    confirmSignOff(type) {
      if (confirm(type === "full" ? "Wirklich abmelden?" : "Begleitung entfernen?")) {
        this.handleSignup(type !== "full", type === "plusOne")
      }
    },

    async downloadTicket() {
      this.ui.generatingTicket = true
      try {
        // Wir müssen UI Controls hier NICHT ausblenden, da wir das hidden element nutzen
        await new Promise((r) => setTimeout(r, 200)) // Kurze Pause für Rendering

        // HIER IST DIE ÄNDERUNG: Wir nehmen das versteckte Ticket-Design
        const element = this.$refs.exportTicket

        const canvas = await html2canvas(element, {
          useCORS: true,
          scale: 2, // Gute Qualität, aber nicht riesig
          backgroundColor: "#000000", // Sicherstellen, dass Hintergrund schwarz ist
          logging: false,
        })

        const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png", 1.0))

        // Dateiname generieren
        const fileName = `WCF-Party-${this.user.lastName}.png`

        if (window.flutter_inappwebview) {
          const reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onloadend = () => {
            window.flutter_inappwebview.callHandler("blobToBase64Handler", reader.result.split(",")[1], "png", fileName)
          }
        } else {
          saveAs(blob, fileName)
        }
        this.$toast.success("Ticket erfolgreich gespeichert")
      } catch (error) {
        console.error("Screenshot error:", error)
        this.$toast.error("Fehler beim Speichern")
      } finally {
        this.ui.generatingTicket = false
      }
    },
  },
}
</script>

<style scoped>
/* PAGE BACKGROUND */
.party-page-wrapper {
  border-radius: 0;
  background-color: #000;
  position: relative;
  min-width: 100vw;
  min-height: 100vh;
  /* Dark Green Gradient */
  background: linear-gradient(135deg, #000000 0%, #051a0d 100%);
  overflow-y: auto;
}

.party-bg {
  /* Optional: Additional overlay gradient for depth */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 30%, rgba(0, 230, 118, 0.05) 0%, transparent 60%);
  pointer-events: none;
  z-index: 0;
}

.relative-z {
  position: relative;
  z-index: 1;
}

/* MAIN CARD */
.main-card {
  background-color: #121212 !important;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8) !important;
  /* Ensure centering on mobile */
  margin: auto;
  width: 100vw;
}

/* BUTTONS & INPUTS */
.glow-button {
  box-shadow: 0 0 15px rgba(0, 230, 118, 0.4);
  transition: all 0.3s ease;
}
.glow-button:hover {
  box-shadow: 0 0 25px rgba(0, 230, 118, 0.7);
  transform: translateY(-2px);
}

.centered-input >>> input {
  text-align: center;
}
.centered-input >>> .v-input__slot {
  border-color: rgba(255, 255, 255, 0.1) !important;
}

/* TICKET STYLES */
.ticket-card {
  background: #1e1e1e;
  border-radius: 12px;
  padding: 0;
  position: relative;
  border: 1px solid #333;
  margin-top: 10px;
  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.5);
  /* Cutout Effect */
  clip-path: polygon(0% 0%, 100% 0%, 100% calc(100% - 12px), 96% 100%, 4% 100%, 0% calc(100% - 12px));
}

.rip-line {
  position: absolute;
  top: -1px;
  left: 12px;
  right: 12px;
  height: 2px;
  border-top: 2px dashed #444;
}

.success-gradient {
  background: linear-gradient(90deg, #00c853, #00e676);
  box-shadow: 0 4px 12px rgba(0, 230, 118, 0.2);
}

.ticket-id {
  letter-spacing: 2px;
  font-family: monospace;
  opacity: 0.5;
}

.tracking-wider {
  letter-spacing: 1.5px;
}

.leading-tight {
  line-height: 1.2;
}

.text-shadow {
  text-shadow: 0px 4px 15px rgba(0, 0, 0, 1);
}

/* Animations */
.pulse-animation {
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* EXPORT TICKET STYLING */
.export-ticket-layout {
  width: 600px; /* Fixe Breite für hohe Qualität */
  background-color: #000000;
  color: white;
  font-family: "Roboto", sans-serif;
  border: 2px solid #00e676;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
}

.ticket-header {
  position: relative;
  height: 250px;
  overflow: hidden;
}

.ticket-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.6;
}

.header-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px;
  background: linear-gradient(to top, #000 0%, transparent 100%);
}

.wcf-logo {
  font-size: 1.5rem;
  font-weight: 900;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #fff;
}

.party-title {
  font-size: 3rem;
  line-height: 1;
  font-weight: 900;
  text-transform: uppercase;
  margin-top: 5px;
  text-shadow: 0 4px 10px rgba(0, 0, 0, 0.8);
}

.ticket-body {
  padding: 30px;
  background: #121212;
  display: flex;
  flex-wrap: wrap;
}

.ticket-row {
  width: 50%;
  margin-bottom: 25px;
}

.ticket-row.full-width {
  width: 100%;
}

.ticket-label {
  font-size: 0.8rem;
  color: #888;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.ticket-value {
  font-size: 1.4rem;
  font-weight: bold;
  color: #fff;
}

.guest-name {
  font-size: 2rem;
  color: #00e676;
}

.ticket-sub {
  font-size: 0.9rem;
  color: #666;
}

.dashed-line {
  width: 100%;
  height: 2px;
  border-bottom: 2px dashed #333;
  margin: 10px 0 25px 0;
}

.ticket-footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.qr-placeholder {
  background: #fff;
  padding: 5px;
  border-radius: 5px;
}
.qr-placeholder .v-icon {
  color: #000 !important;
}

.ticket-id-box {
  text-align: right;
}
.code-font {
  font-family: monospace;
  font-size: 1.2rem;
  letter-spacing: 2px;
  color: #00e676;
}

.watermark {
  position: absolute;
  bottom: 10px;
  right: -20px;
  font-size: 4rem;
  font-weight: 900;
  color: rgba(255, 255, 255, 0.03);
  transform: rotate(-5deg);
  white-space: nowrap;
  pointer-events: none;
}
</style>
